/* eslint-disable */
import React from "react";
import { useParams } from "react-router-dom";
import { ORGANISATION_TAGS } from "../../../services/constants";
import { localize } from "../../../services/localize";
import { useEffect, useState } from "react";
import {
  fetchGraphQL,
  fetchOrganisationDetailGet,
  fetchOrganisationGet,
  fetchOrganisationOrganisationUsersGet,
  fetchOrganisationsActivityPost,
  fetchOrganisationsTransferPost,
  fetchOrganisationTagPost,
  fetchOrganisationTimeline,
  fetchOrganisationUserGet,
  fetchOrganisationUserPost,
} from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import ModelComponentOrganisation from "../../../ui-components/model-component-organisation/model-component-organisation";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";

import NimbusTimelineItem from "../../../ui-components/nimbus-timeline-item/nimbus-timeline-item";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo";
import ModelTag from "../../../ui-components/model-tag/model-tag";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";
import ModelComponentOrganisationUser from "../../../ui-components/model-component-organisation-user/model-component-organisation-user.tsx";
import ModelComponentOrganisationDetail from "../../../ui-components/model-component-organisation-detail/model-component-organisation-detail.js";
import ModelComponentOrganisationStatus from "../../../ui-components/model-component-organisation-status/model-component-organisation-status.tsx";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import ModelFilter from "../../../ui-components/model-filter/model-filter.tsx";
import ModelComponentOrganisationDetailMedia from "../../../ui-components/model-component-organisation-detail-media/model-component-organisation-detail-media.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";
import ModelComponentOrganisationTag from "../../../ui-components/model-component-organisation-tag/model-component-organisation-tag.js";
import RaindropInputDropdown from "../../../ui-components/raindrop-input-dropdown/raindrop-input-dropdown.tsx";

const OrganisationTimelineFilter = ({ ignoreTypes, toggleType }) => {
  return (
    <div className="flex flex-row gap-2 p-2 flex-wrap">
      <ModelFilter
        type="NOTE"
        isHidden={ignoreTypes.includes("NOTE")}
        onClick={() => toggleType("NOTE")}
      />
      <ModelFilter
        type="ORGANISATION_TRANSFER"
        isHidden={ignoreTypes.includes("ORGANISATION_TRANSFER")}
        onClick={() => toggleType("ORGANISATION_TRANSFER")}
      />
      <ModelFilter
        type="ORGANISATION_ACTIVITY"
        isHidden={ignoreTypes.includes("ORGANISATION_ACTIVITY")}
        onClick={() => toggleType("ORGANISATION_ACTIVITY")}
      />
    </div>
  );
};

const OrganisationTimeline = ({ organisationId, refreshCount }) => {
  const [timeline, setTimeline] = useState(null);
  const [ignoreTypes, setIgnoreTypes] = useState([]);

  useEffect(() => {
    fetchOrganisationTimeline({ organisationId }).then((timeline) => {
      setTimeline(timeline);
    });
  }, [organisationId, refreshCount]);

  const toggleType = (type) => {
    if (ignoreTypes.includes(type)) {
      setIgnoreTypes(ignoreTypes.filter((t) => t !== type));
    } else {
      setIgnoreTypes([...ignoreTypes, type]);
    }
  };

  return (
    <div className="flex flex-col h-full gap-3">
      <div className={`flex flex-row gap-3 font-bold text-3xl w-full`}>
        Timeline
      </div>

      <OrganisationTimelineFilter
        ignoreTypes={ignoreTypes}
        toggleType={toggleType}
      />

      <RaindropScrollContainer>
        {timeline &&
          timeline.items
            .filter((item) => !ignoreTypes.includes(item.type))
            .map((timelineItem, index) => {
              return (
                <NimbusTimelineItem
                  key={index}
                  type={timelineItem.type}
                  date={timelineItem.date}
                  data={timelineItem.data}
                />
              );
            })}
      </RaindropScrollContainer>
    </div>
  );
};

const OrganisationTitle = ({ src, name, created_at }) => {
  return (
    <div className="flex flex-col w-full py-4">
      <div className="flex flex-row gap-4 items-center">
        <OrganisationLogo src={src} isLarge={true} />
        <div className="flex flex-col gap-1">
          <div className="font-bold text-3xl">{name}</div>
          <div className="text-color-dark-text-secondary">
            Member since {created_at}
          </div>
        </div>
      </div>
    </div>
  );
};

const OrganisationUserForm = ({ organisationId, setCurrentModalComponent }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [inputNameLegal, setInputNameLegal] = useState("");
  const [inputNamePreferred, setInputNamePreferred] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [inputDateOfBirth, setInputDateOfBirth] = useState("");
  const [inputAddressLine1, setInputAddressLine1] = useState("");
  const [inputAddressPostcode, setInputAddressPostcode] = useState();
  const [inputAddressCity, setInputAddressCity] = useState();

  const onSubmit = () => {
    setIsLoading(true);

    fetchOrganisationUserPost({
      organisationId: organisationId,
      nameLegal: inputNameLegal,
      namePreferred: inputNamePreferred,
      email: inputEmail,
      dateOfBirth: inputDateOfBirth,
      addressLine1: inputAddressLine1,
      addressPostcode: inputAddressPostcode,
      addressCity: inputAddressCity,
    })
      .then(() => {
        setCurrentModalComponent(null);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <form className="flex flex-col gap-2 w-full max-w-lg">
      <div className="flex flex-col w-full">
        <h3 className="text-left font-bold text-lg">
          Create Organisation User
        </h3>
      </div>
      <div className="flex flex-row gap-2">
        <div className="flex flex-col gap-2">
          <RaindropInput
            label={"Name Legal"}
            value={inputNameLegal}
            example={"John Doe"}
            onChange={(e) => setInputNameLegal(e.target.value)}
          />
          <RaindropInput
            label="Name Preferred"
            value={inputNamePreferred}
            example="John"
            onChange={(e) => setInputNamePreferred(e.target.value)}
          />
          <RaindropInput
            label="Email"
            value={inputEmail}
            example={"john@example.com"}
            onChange={(e) => setInputEmail(e.target.value)}
          />
          <RaindropInput
            label="Date of Birth"
            value={inputDateOfBirth}
            example={"1997-09-11"}
            onChange={(e) => setInputDateOfBirth(e.target.value)}
          />
        </div>
        <div className="flex flex-col gap-2">
          <RaindropInput
            label="Address Line 1"
            value={inputAddressLine1}
            example="123 Example Street"
            onChange={(e) => setInputAddressLine1(e.target.value)}
          />
          <RaindropInput
            label="Address Postcode"
            value={inputAddressPostcode}
            example="E1 1AA"
            onChange={(e) => setInputAddressPostcode(e.target.value)}
          />
          <RaindropInput
            label="Address City"
            value={inputAddressCity}
            example="London"
            onChange={(e) => setInputAddressCity(e.target.value)}
          />
        </div>
      </div>
      <div className="flex flex-row">
        <Spacer />
        <RaindropButton
          title="Submit"
          onClick={onSubmit}
          isLoading={isLoading}
        />
      </div>
    </form>
  );
};

const OrganisationTagForm = ({ organisationId, setCurrentModalComponent }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState(ORGANISATION_TAGS[0]);

  const onSubmit = () => {
    setIsLoading(true);

    fetchOrganisationTagPost({
      organisationId: organisationId,
      value: inputValue,
    })
      .then(() => {
        setCurrentModalComponent(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <form className="flex flex-col gap-2 w-full max-w-lg">
      <div className="flex flex-col w-full">
        <h3 className="text-left font-bold text-lg">Create Organisation Tag</h3>
      </div>
      <div className="flex flex-col gap-2">
        <RaindropInputDropdown
          label="Value"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          options={ORGANISATION_TAGS.map((tag) => [tag, localize(tag)])}
        />
      </div>
      <div className="flex flex-row">
        <Spacer />
        <RaindropButton
          title="Submit"
          onClick={onSubmit}
          isLoading={isLoading}
        />
      </div>
    </form>
  );
};

const NimbusOrganisationsInstance = ({ setCurrentModalComponent }) => {
  const { organisationId } = useParams();

  const [refreshCount, setRefreshCount] = useState(0);

  const [organisation, setOrganisation] = useState(null);
  const [organisationUsers, setOrganisationUsers] = useState(null);
  const [organisationDetail, setOrganisationDetail] = useState(null);

  // TODO: this should eventually be the main organisation
  const [graphqlOrganisation, setGraphqlOrganisation] = useState(null);

  const onRefresh = () => {
    setRefreshCount(refreshCount + 1);
  };

  useEffect(() => {
    fetchOrganisationGet({ organisationId }).then((org) => {
      setOrganisation(org);
    });
  }, [organisationId, refreshCount]);

  useEffect(() => {
    fetchOrganisationOrganisationUsersGet({
      organisationId: organisationId,
    }).then((organisationUsers) => {
      setOrganisationUsers(organisationUsers);
    });
  }, [organisationId, refreshCount]);

  useEffect(() => {
    fetchOrganisationDetailGet({ organisationId }).then(
      (organisationDetail) => {
        setOrganisationDetail(organisationDetail.organisation_detail);
      }
    );
  }, [organisationId, refreshCount]);

  useEffect(() => {
    fetchGraphQL(`
      query {
        organisation(id: "${organisationId}") {
          id
          urlDonationPage
          publicEmail
        }
      }
    `).then((response) => {
      console.log("RD-3333", response);
      setGraphqlOrganisation(response.data.organisation);
    });
  }, [organisationId, refreshCount]);

  if (organisation === null) {
    return <RaindropLoadingElement />;
  }

  return (
    <div className="flex flex-row justify-around h-full w-full ">
      <div className="flex flex-col gap-2 w-full max-w-lg">
        <OrganisationTitle
          src={organisation.presigned_url_logo}
          name={organisation.name}
          created_at={organisation.created_at}
        />

        <RaindropScrollContainer additionalClassNames="gap-4">
          <div className="flex flex-row w-full gap-2 overflow-x-auto no-scrollbar">
            <RaindropButton
              title="Add Tag"
              icon="fa-plus"
              onClick={() =>
                setCurrentModalComponent(
                  <OrganisationTagForm
                    organisationId={organisationId}
                    setCurrentModalComponent={setCurrentModalComponent}
                  />
                )
              }
            />
            <RaindropButton
              title="Add Organisation User"
              icon="fa-plus"
              onClick={() => {
                setCurrentModalComponent(
                  <OrganisationUserForm
                    organisationId={organisationId}
                    setCurrentModalComponent={setCurrentModalComponent}
                  />
                );
              }}
            />

            <RaindropButton
              title="Donation Page"
              to={graphqlOrganisation?.urlDonationPage}
              target="_blank"
              isDisabled={graphqlOrganisation?.urlDonationPage === null}
            />
          </div>

          <ModelComponentOrganisation
            organisationId={organisation.id}
            src={organisation.logo_url}
            title={organisation.name}
            onRefresh={onRefresh}
            paymentProviderIdentifierStripe={
              organisation.payment_provider_identifier_stripe
            }
            rawData={organisation}
            status={organisation.status}
            organisationType={organisation.organisation_type}
            urlDonationPage={graphqlOrganisation?.urlDonationPage}
            publicEmail={graphqlOrganisation?.publicEmail}
          />

          {organisationUsers &&
            organisationUsers.map((organisationUser) => {
              return (
                <ModelComponentOrganisationUser
                  id={organisationUser.id}
                  nameLegal={organisationUser.name_legal}
                  email={organisationUser.email}
                  namePreferred={organisationUser.name_preferred}
                  dateOfBirth={organisationUser.date_of_birth}
                  addressLine1={organisationUser.address_line1}
                  addressPostcode={organisationUser.address_postcode}
                  addressCity={organisationUser.address_city}
                  rawData={organisationUser}
                />
              );
            })}

          {organisation.organisation_tags &&
            organisation.organisation_tags.map((organisation_tag) => (
              <ModelComponentOrganisationTag
                id={organisation_tag.id}
                value={organisation_tag.value}
                rawData={organisation_tag}
              />
            ))}

          <div className="flex flex-col w-full">
            {organisationDetail && (
              <ModelComponentOrganisationDetail
                key={organisationDetail?.id}
                organisationDetailId={organisationDetail?.id}
                organisationId={organisation.id}
                descriptionLong={organisationDetail?.description_long}
                organisationDetailMediaObjects={
                  organisationDetail?.organisation_detail_media_objects
                }
                rawData={organisationDetail}
              />
            )}
            {organisationDetail &&
              organisationDetail?.organisation_detail_media_objects.map(
                (odm) => (
                  <>
                    <div className="w-[50%] border-r-2 border-color-border-tertiary h-2" />
                    <ModelComponentOrganisationDetailMedia
                      organisationDetailMediaId={odm.id}
                      caption={odm.caption}
                      imageUrl={odm.media.presigned_url}
                    />
                  </>
                )
              )}
          </div>
        </RaindropScrollContainer>
      </div>
      <div className="w-full max-w-lg">
        <OrganisationTimeline
          organisationId={organisation.id}
          refreshCount={refreshCount}
        />
      </div>
    </div>
  );
};

export default NimbusOrganisationsInstance;
